/**
 * A mixin to get/set the selected Timeframe and filter entries by it.
 *
 * Used e.g. to filter SpotEntry lists on the DecoderDetail page.
 *
 */
const selectedTimeframes = {
  computed: {
    selectedTimeframes: {
      get() {
        return this.$store.state.common.selectedTimeframes;
      },
      set(timeframes) {
        return this.$store.commit('SET_SELECTED_TIMEFRAMES', timeframes);
      },
    },
    selectedTimeframeIds() {
      return this.selectedTimeframes.map((x) => x.id);
    },
    /**
     * Allow entries that match selected timeframes or don't have one.
     *
     * Depends on:
     *   - this.entries
     */
    entriesForSelectedTimeframes() {
      return this.filterEntriesForSelectedTimeframes(this.entries);
    },
  },
  methods: {
    filterEntriesForSelectedTimeframes(entries) {
      if (!entries) {
        return [];
      }
      if (this.selectedTimeframes.length == 0) {
        return entries;
      }
      return entries.filter((entry) => {
        const entryTimeframes = entry.timeframes || [];
        return (
          entryTimeframes.length == 0 ||
          entryTimeframes.filter((timeframe) =>
            this.selectedTimeframeIds.includes(timeframe.id)
          ).length > 0
        );
      });
    },
    addSelectedTimeframe(timeframe) {
      this.selectedTimeframes = [...this.selectedTimeframes, timeframe];
    },
    removeSelectedTimeframe(timeframe) {
      this.selectedTimeframes = this.selectedTimeframes.filter(
        (x) => x.id != timeframe.id
      );
    },
  },
};

export default selectedTimeframes;



// WEBPACK FOOTER //
// ./src/mixins/selectedTimeframes.js